import { render } from "./ImageEllipseOutline.vue?vue&type=template&id=08486f68&scoped=true&ts=true"
import script from "./ImageEllipseOutline.vue?vue&type=script&lang=ts"
export * from "./ImageEllipseOutline.vue?vue&type=script&lang=ts"

import "./ImageEllipseOutline.vue?vue&type=style&index=0&id=08486f68&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08486f68"]])

export default __exports__